import type { ActualCostEvent } from "./actualEvents";
import type { FinancialBucket } from "../domain/buckets";

/** A cost claim and a bank movement answer different questions. */
export function classifyActualCash(event: ActualCostEvent, categoryBucket: FinancialBucket, nonCashAllocationIds: ReadonlySet<string> = new Set()): { bucket: FinancialBucket; costCents: number; cashCents: number } {
  const bucket = event.bucketOverride ?? categoryBucket;
  const costCents = event.voidedAt === null ? event.amountCents + event.taxCents : 0;
  const cashCents = costCents === 0 || event.source === "mileage" || (event.source === "allocation" && nonCashAllocationIds.has(event.id)) ? 0 : -costCents;
  return { bucket, costCents, cashCents };
}
